// Global packages and components
import { ChevronDownIcon } from '@heroicons/react/24/outline'

// Types
interface Props {
  activeOrder: string | null
  setOrderBy: (e: string) => void
  options: { value: string; label: string }[]
}

// Main export
const OrderBy = ({ activeOrder, setOrderBy, options }: Props) => (
  <div className="flex items-center justify-end gap-3">
    <div className="relative">
      <p className="pointer-events-none absolute left-4 top-1/2 mb-0 -translate-y-1/2 text-neutral-400">
        Order by:
      </p>
      <select
        name="order-by"
        id="products-order-by"
        className="appearance-none rounded-xl border border-neutral-300 bg-white py-3 pl-24 pr-12"
        onChange={e => setOrderBy(e.currentTarget.value)}
        value={activeOrder ?? 'relevance'}
      >
        {options.map((e, i) => (
          <option
            key={i}
            value={e.value}
          >
            {e.label}
          </option>
        ))}
      </select>
      <ChevronDownIcon className="pointer-events-none absolute right-4 top-1/2 size-5 -translate-y-1/2" />
    </div>
  </div>
)

export default OrderBy
